@layer refine.base {
  :host {
    display: inline-flex;
    flex-direction: row;
  }

  /* Overlap avatars, latest first */
  ::slotted(ore-avatar) {
    --avatar-border: var(--border-2) solid var(--color-canvas);

    margin-left: calc(var(--avatar-group-overlap, -0.75rem));
  }

  ::slotted(ore-avatar:first-child) {
    margin-left: 0;
  }

  :host([dir='rtl']) ::slotted(ore-avatar),
  :host(:dir(rtl)) ::slotted(ore-avatar) {
    margin-right: calc(var(--avatar-group-overlap, -0.75rem));
    margin-left: 0;
  }

  :host([dir='rtl']) ::slotted(ore-avatar:first-child),
  :host(:dir(rtl)) ::slotted(ore-avatar:first-child) {
    margin-right: 0;
  }

  ::slotted(ore-avatar[data-avatar-group-hidden]) {
    display: none;
  }

  .overflow-badge {
    --_size: var(--avatar-size, var(--size-10));

    box-sizing: border-box;
    display: inline-flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: var(--_size);
    height: var(--_size);
    margin-left: calc(var(--avatar-group-overlap, -0.75rem));
    font-size: var(--text-xs);
    font-weight: var(--font-semibold);
    color: var(--color-contrast-700);
    user-select: none;
    background: var(--color-contrast-200);
    border: var(--border-2) solid var(--color-canvas);
    border-radius: var(--rounded-full);
  }

  :host([dir='rtl']) .overflow-badge,
  :host(:dir(rtl)) .overflow-badge {
    margin-right: calc(var(--avatar-group-overlap, -0.75rem));
    margin-left: 0;
  }
}
